import * as React from "react";
const SkipIcon=(props)=>(
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M23 4v6h-6"/>
  <path d="M20.49 15A9 9 0 1 1 21 12"/>
</svg>
 
);
export default SkipIcon;